<template>
	<div v-if="reseller">
		<bread-crumbs
			:bread-crumbs="breadCrumbs"
			current-title="Profile"
			class="breadcrumbstyle"
		/>
		<v-container
			fluid
		>
			<v-row>
				<v-col
					cols="3"
				>
					<model-detail
						:items="reseller"
						title="Details"
					/>
				</v-col>
				<v-col
					cols="3"
				>
					<model-detail
						:items="resellerAddress"
						title="Address"
					/>
				</v-col>
				<v-col cols="5">
					<v-card>
						<v-card-title>
							<translate>Users</translate>
						</v-card-title>
						<v-data-table
							:headers="headers"
							:items="resellerUsers"
							hide-default-footer
							class="elevation-1"
						/>
					</v-card>
				</v-col>
			</v-row>
			<v-row>
				<v-col
					cols="3"
				>
					<v-card>
						<v-card-title>
							<translate>Api key</translate>
						</v-card-title>
						<v-card-text>
							<v-textarea
								v-if="apiKey"
								:model-value="apiKey"
								readonly
								rows="2"
								no-resize
							/>
						</v-card-text>
						<v-card-actions>
							<v-btn
								color="primary"
								@click="generateApiKey"
							>
								<translate>Generate new api key</translate>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import {
	axios,
} from '../../../services/axios-service';import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'ResellerCompanyData',
	data () {
		return {
			breadCrumbs: {
				'/resellers': 'Resellers'
			},
			reseller: {
			},
			resellerAddress: {
			},
			resellerUsers: [],
			apiKey: '',
		};
	},

	computed: {
		headers () {
			return [
				{
					title: this.$gettext('Name'), align: 'start', sortable: false, value: 'name'
				},
				{
					title: this.$gettext('email'), sortable: false, value: 'email'
				},
				{
					title: this.$gettext('Phone number'), sortable: false, value: 'phoneNumber'
				},
			];
		}
	},

	created () {
		this.getCompanyData();
	},

	methods: {
		/**
		 * Get all reseller data.
		 *
		 * @returns {void}
		 */
		getCompanyData () {
			axios.get('/resellers/companydata/data')
				.then(({
					data: data
				}) => {
					this.reseller = data.reseller;
					this.resellerAddress = data.resellerAddress;
					this.resellerUsers = data.resellerUsers;
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during data retrieval'));
				});
		},

		/**
		 * Generates an api key for the current reseller.
		 *
		 * @returns {void}
		 */
		generateApiKey () {
			axios.post('/resellers/companydata')
				.then(({
					data: data
				}) => {
					this.apiKey = data;
				})
				.catch(() => {
					displayError(this.$gettext('Could not generate api key'));
				});
		}
	}
};
</script>
